<template>
  <div class="network-table-content">
    <v-data-table
      class="network-table-content-body"
      :headers="headers"
      :items="list"
      :loading="loading"
      :hide-actions="true"
      :no-data-text="$t('message.generics.message.noResultsFound')"
      :no-results-text="$t('message.generics.message.noData')"
    >
      <template slot="items" slot-scope="props">
        <AccessPointControllerNetworkListItem
          :item="props.item"
          :selected-networks="selectedNetworks"
          @change="emitSelectedNetworks"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import AccessPointControllerNetworkListItem from "./item/AccessPointControllerNetworkListItem.vue";
import { cloneDeep } from "lodash";

export default {
  components: {
    AccessPointControllerNetworkListItem,
  },

  data() {
    return {
      list: [],
      loading: false,
    };
  },

  computed: {
    headers() {
      return [
        { text: "", value: "", sortable: false, width: 75 },
        {
          text: this.$t("message.generics.message.name"),
          value: "name",
          sortable: false,
        },
      ];
    },
  },

  props: {
    controllerId: {
      type: Number,
      required: true,
    },
    selectedNetworks: {
      type: Array,
      required: true,
    },
  },

  methods: {
    async emitSelectedNetworks(val) {
      let value = cloneDeep(this.selectedNetworks);
      if (val.action === "select") {
        const exists = value.some((network) => network.id === val.network.id);
        if (!exists) {
          value.push(val.network);
        }
      } else {
        value = value.filter((network) => network.id !== val.network.id);
      }
      this.$emit("on-selected-network", value);
    },

    async getNetworks() {
      try {
        this.loading = true;
        const response = await this.$api.beholder.getControllerNetworks(
          this.controllerId
        );
        this.list = response;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    this.getNetworks();
  },
};
</script>

<style lang="scss" scoped>
.network-table-content {
  margin: 15px 0;
  width: 100%;

  .network-table-content-body {
    padding: 0 20px 10px;
    border: 2px solid #c4c4c4;
    border-radius: 8px;
  }
}
</style>
